import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="landing-container">
        <img 
          src="/icon.png" 
          alt="Icon" 
          className="centered-image"
        />
        <p className="title">초성게임</p>
        <p className="subtext">이제 시작한 자도 면제는 없다!</p>
      </div>
      <footer className="footer">
        <a href="/privacy" className="privacy-link">개인정보 처리방침</a>
      </footer>
    </div>
  );
}

export default App;
